module.exports = __webpack_public_path__ + "assets/icon-portablePosts-metalPortable.4bea2380.svg";